import { BaseTheme } from '@triumph/design-system';
import { defaultsDeep } from 'lodash';

const theme = {
    colors: {
        primary: {
            tbcNavy: '#D2B48C',
        },
    },
};

export const getCompanyTheme = () => defaultsDeep(theme, BaseTheme);
